module.exports = __webpack_public_path__ + "img/icon-24-ic-add.1e6d496e.svg";